import { gql } from '@apollo/client'

import { USER_DETAILS_FRAGMENT } from '../fragments'

const CREATE_USER_MUTATION = gql`
  mutation createUser($data: UserInput!) {
    createUser(data: $data) {
      ...UserDetailsFragment
    }
  }
  ${USER_DETAILS_FRAGMENT}
`

export default CREATE_USER_MUTATION
